import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

const initTopbarSwiper = () => {
    const el = document.querySelector('[data-topbar-swiper]');
    if (!el) return;

    const isMobile = () => window.innerWidth < 1024;
    let instance = null;

    const build = () => {
        if (!isMobile() || instance) return;
        const swiperEl = el.querySelector('.swiper');
        const prev = el.querySelector('.TopbarNav--prev');
        const next = el.querySelector('.TopbarNav--next');

        instance = new Swiper(swiperEl, {
            modules: [Navigation],
            slidesPerView: 1,
            loop: true,
            navigation: {
                prevEl: prev,
                nextEl: next,
            },
        });
    };

    const destroy = () => {
        if (instance && !isMobile()) {
            instance.destroy(true, true);
            instance = null;
        }
    };

    build();
    window.addEventListener('resize', () => {
        destroy();
        build();
    });
};

document.addEventListener('DOMContentLoaded', initTopbarSwiper);
